import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import DialogContentText from "@material-ui/core/DialogContentText";

class DialogInternet extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            rowData: props.rowData,
        }
    }
    confirmar =() =>{
        let folio = this.state.rowData.folio
        this.props.confirmarCerrar(folio,"cerrado")
    }
    render() {
        return(
            <Dialog
                open={true}
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Sin conexión a internet</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       Esta seguro que quiere cerrar el inventario sin tener conexión a internet?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={this.confirmar} color="primary">
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
export default DialogInternet;